import React, {useEffect, useState} from 'react';
import {withTranslation} from "../../../../i18n";
import {useRouter} from "next/router";
import Link from "next/link";
import DomService from "@/services/utils/DomService";
import PublicationService from "@/services/domain/PublicationsService";
import Pagination from "../../../../components/widgets/Pagination/Pagination"
import css from './PublicationsList.module.scss';
import {PublicationStatus} from "@/models/Publication";

const namespacesRequired = ['publications'];

const PublicationsList = ({t, publications, searchResultNumber, publicationsPerPage}) => {

  const router = useRouter();

  const {page} = router.query;
  const [headerRef] = useState(React.createRef());
  const [didMountRender, setDidMountRender] = useState(false);
  const [firstGridPublications, setFirstGridPublications] = useState(publications.slice(0, publicationsPerPage / 2));
  const [secondGridPublications, setSecondGridPublications] = useState(publications.slice(publicationsPerPage / 2, publicationsPerPage));

  const handlePageClick = data => {
    if (didMountRender) {
      let currentUrlParams = new URLSearchParams(window.location.search);
      currentUrlParams.set("page", data.selected + 1);

      router.push(window.location.pathname + "?" + currentUrlParams.toString()).then(() => handleScrollToHeader());
    } else {
      setDidMountRender(true);
    }
  };

  const handleScrollToHeader = () => {

    if (!headerRef || !headerRef.current) {
      return;
    }
    const elementOffset = DomService.offset(headerRef.current);
    const navBarOffset = document.querySelector('nav').offsetHeight + 10;
    DomService.scrollTo(elementOffset, navBarOffset, 500);
  };

  useEffect(() => {
    setFirstGridPublications(publications.slice(0, publicationsPerPage / 2))
    setSecondGridPublications(publications.slice(publicationsPerPage / 2, publicationsPerPage))
  }, [publications])

  return (
    <div className={css.publicationlist}>
      <div>
        {firstGridPublications && firstGridPublications.length > 0 && (
          <div className={css.grid}>
          {firstGridPublications.map((publication, i) => (
            <Link
              key={i}
              href={PublicationService.getPublicationLink(publication, t)}
              passHref
              className={css.grid__item}>

              {publication.photos?.[0] && (
                  <div
                    className={css.grid__item__image}
                    style={{ backgroundImage: `url(${publication.photos[0]?.url || ''})` }}
                  />
                )}
              <div className={css.grid__item__info}>
                <p className={css.grid__item__info__title}>{publication.title}</p>
                <div className={css.grid__item__info__category}>
                  <p>{t('publications:publication.category-' + publication.category)}</p>
                  {publication.status === PublicationStatus.INACTIVE && (
                    <p>{t('publications:publication.inactive')}</p>
                  )}
                </div>
              </div>

            </Link>
          ))}
        </div>

        )}

      {secondGridPublications && secondGridPublications.length > 0 && (
        <div className={css.grid}>
          {secondGridPublications.map((publication, i) => (
            <Link
              href={PublicationService.getPublicationLink(publication, t)}
              key={i}
              passHref
              className={css.grid__item}>

              {publication.photos?.[0] && (
                <div
                  className={css.grid__item__image}
                  style={{ backgroundImage: `url(${publication.photos[0]?.url || ''})` }}
                />
              )}
              <div className={css.grid__item__info}>
                <p className={css.grid__item__info__title}>{publication.title}</p>
                <div className={css.grid__item__info__category}>
                  <p>{t('publications:publication.category-' + publication.category)}</p>
                  {publication.status === PublicationStatus.INACTIVE && (
                    <p>{t('publications:publication.inactive')}</p>
                  )}
                </div>
              </div>

            </Link>
          ))}
        </div>
      )}

      </div>
      <Pagination
        pageCount={searchResultNumber ? Math.ceil(searchResultNumber / publicationsPerPage) : 0}
        pageRangeDisplayed={100} // to display by decile , we're taking 100 pages max at a time
        handlePageClick={handlePageClick}
        initialPage={Number(page - 1) || 0}
        marginPagesDisplayed={1}
      />
    </div>
  );
};


export default withTranslation(namespacesRequired)(PublicationsList);
